import { Link } from 'react-router-dom';
import Breadcrumb from './BreadCrumbs';
import ScrollToTop from '../utils/scrollToTop.js';

const Section = ({ id, title, children }) => (
  <section id={id} className="scroll-mt-28 border-b border-stone-200 py-8 last:border-0">
    <h2 className="text-2xl font-bold text-green-800">{title}</h2>
    <div className="mt-3 space-y-3 leading-7 text-gray-700">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  return (
    <main>
      <ScrollToTop />
      <section className="bg-green-900 px-6 py-20 text-center text-white">
        <p className="text-sm font-semibold uppercase tracking-[0.22em] text-yellow-300">Vasundhara Seeds</p>
        <h1 className="mt-3 text-4xl font-bold">Privacy Policy</h1>
        <p className="mx-auto mt-4 max-w-2xl text-green-50">How we collect, use, and protect information shared through our website.</p>
      </section>
      <Breadcrumb />

      <div className="mx-auto max-w-5xl px-6 py-12 lg:flex lg:gap-12">
        <aside className="mb-8 shrink-0 lg:mb-0 lg:w-56">
          <p className="mb-3 font-semibold text-green-900">On this page</p>
          <nav aria-label="Privacy policy sections" className="space-y-2 text-sm">
            <a href="#information-we-collect" className="block text-green-800 hover:underline">Information we collect</a>
            <a href="#how-we-use-information" className="block text-green-800 hover:underline">How we use it</a>
            <a href="#sharing-and-security" className="block text-green-800 hover:underline">Sharing and security</a>
            <a href="#your-choices" className="block text-green-800 hover:underline">Your choices</a>
            <a href="#contact-us" className="block text-green-800 hover:underline">Contact us</a>
          </nav>
        </aside>

        <article className="min-w-0 flex-1">
          <p className="rounded-lg bg-yellow-50 px-4 py-3 text-sm text-yellow-900">Last updated: September 22, 2026</p>
          <Section id="information-we-collect" title="Information we collect">
            <p>We may collect information about you in various ways. The information we may collect includes:</p>
            <ul className="list-disc space-y-3 pl-5">
              <li><strong>Personal Information:</strong> We collect personal details like your name, email address, and phone number etc. By sharing your information, you authorize Vasundhara Seeds to contact you via SMS, RCS, WhatsApp, Email, and other communication channels. This consent overrides any NDNC/DND registration as per TRAI regulations.</li>
              <li><strong>Communication Data:</strong> Messages, inquiries, and other communications you send to us.</li>
              <li><strong>Usage Data:</strong> Information about how you access and use our website, including your IP address, browser type, and pages visited.</li>
            </ul>
          </Section>
          <Section id="how-we-use-information" title="How we use your information">
            <p>We use the information you share to respond to enquiries, provide information about our products and services, and improve our website and customer support. If you opt in, we may contact you through RCS about your enquiry. We only use your details for purposes connected with your request or as required by applicable law.</p>
          </Section>
          <Section id="sharing-and-security" title="Sharing and security">
            <p>We do not sell personal information. Information may be shared with service providers who help us operate the website or respond to an enquiry, when necessary and subject to appropriate safeguards. We take reasonable measures to protect information, but no online transmission or storage system can be guaranteed completely secure.</p>
          </Section>
          <Section id="your-choices" title="Your choices">
            <p>You may ask to review, correct, or request deletion of information you have provided to us. You may also withdraw RCS consent at any time. To make a request, please <a href="mailto:sarang@vasundharaseeds.in?subject=Privacy%20request" className="font-semibold text-green-800 underline">email our privacy contact</a>. You may also choose not to provide information; however, we may then be unable to respond to a particular enquiry.</p>
          </Section>
          <Section id="contact-us" title="Contact us">
            <p>For questions about this policy or your personal information, contact Vasundhara Seeds at <a href="mailto:sarang@vasundharaseeds.in" className="font-semibold text-green-800 underline">sarang@vasundharaseeds.in</a>, call <a href="tel:+919425332127" className="font-semibold text-green-800 underline">+91 9425332127</a>, or visit our <Link to="/contact" className="font-semibold text-green-800 underline">Contact page</Link>.</p>
          </Section>
        </article>
      </div>
    </main>
  );
}
